import React, { useEffect, useState } from "react";
import ForwardIcon from "@mui/icons-material/Forward";
import { Box, Button, Divider, Typography } from "@mui/material";
import useAxiosPrivate from "contexts/interceptors/axios";
import AddKSASubjectModal from "modals/smea/ksaSubjects/AddKSASubjectModal";
import UpdateKSASubjectModal from "modals/smea/ksaSubjects/UpdateKSASubjectModal";
import KSATable from "./KSATable";

export default function KSASubjects() {
  const axiosPrivate = useAxiosPrivate();

  const [KSASubjectsData, setKSASubjectsData] = useState([]);
  const [selectedKSASubject, setSelectedKSASubject] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [disabled, setDisabled] = useState(false);

  const [openAddModal, setOpenAddModal] = useState(false);
  const [openUpdateModal, setOpenUpdateModal] = useState(false);

  const handleOpen = (type) => {
    if (type === "add") {
      setOpenAddModal(true);
    } else if (type === "update") {
      setOpenUpdateModal(true);
    }
  };

  const handleGetAll = () => {
    setLoading(true);
    setError("");

    axiosPrivate
      .get(`/ksa/getAllKSASubjects`)
      .then((e) => {
        setKSASubjectsData(e.data);
      })
      .catch((err) => {
        setError(err?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetAll();
  }, []);

  useEffect(() => {
    if (!selectedKSASubject?.length) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [selectedKSASubject]);

  return (
    <Box
      sx={{
        p: "20px",
      }}
    >
      <AddKSASubjectModal
        handleClose={() => setOpenAddModal(false)}
        open={openAddModal}
        updateTableFunction={handleGetAll}
      />
      <UpdateKSASubjectModal
        handleClose={() => setOpenUpdateModal(false)}
        open={openUpdateModal}
        data={selectedKSASubject && selectedKSASubject[0]}
        updateTableFunction={handleGetAll}
      />
      <Box
        borderRadius="10px"
        boxShadow="3px 2px 15px 3px rgba(100, 100, 100, 0.8)"
        p="1rem"
        sx={{ backgroundColor: "rgba(240, 240, 240, 1)" }}
      >
        <Divider>
          <Typography
            sx={{
              textTransform: "uppercase",
              fontSize: "25px",
            }}
          >
            KSA Subjects
          </Typography>
        </Divider>
        <Box>
          {error}
          <KSATable
            data={KSASubjectsData}
            setSelectedData={setSelectedKSASubject}
            loadingState={loading}
            updateTableFunction={handleGetAll}
          />
        </Box>

        <Divider
          variant="middle"
          sx={{ borderTopWidth: "1px", borderTopColor: "grey" }}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
          }}
        >
          <Box>
            <Button
              onClick={() => handleOpen("add")}
              sx={{
                backgroundColor: "#2e3887",
                color: "white",
                "&:hover": {
                  color: "black",
                  backgroundColor: "white",
                },
                fontSize: "14px",
                fontWeight: "bold",
                padding: "10px 20px",
                borderRadius: "5px",
                boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              <ForwardIcon sx={{ mr: "10px" }} />
              Add
            </Button>
          </Box>
          <Box>
            <Button
              onClick={() => handleOpen("update")}
              disabled={disabled}
              sx={{
                backgroundColor: "#2e3887",
                color: "white",
                "&:hover": {
                  color: "black",
                  backgroundColor: "white",
                },
                fontSize: "14px",
                fontWeight: "bold",
                padding: "10px 20px",
                borderRadius: "5px",
                boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              <ForwardIcon sx={{ mr: "10px" }} />
              Update
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
